import React, { ChangeEvent, useState } from "react";
import { Col, Input, message, Modal, Row } from "antd";
import Editor from "../../../../../components/Editor";
import style from "./index.module.scss";
import {
    makeTargetString,
    NoticeTargetType,
    saveMessage,
    TreeNode
} from "../../../../../service/notice";
import { errorMessage } from "../../../../../service/service";
import StudentPicker from "components/StudentPicker";
import _ from "underscore";

interface CreateNoticeProps {
    visible: boolean;
    treeData: TreeNode[];
    onClose: () => void;
    onSuccess: () => void;
}

export default function CreateNotice({
    visible,
    treeData,
    onClose,
    onSuccess
}: CreateNoticeProps) {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [studentNos, setStudentNos] = useState<string[]>([]);

    const [loading, setLoading] = useState(false);

    // 错误状态
    const [error, setError] = useState({
        title: "",
        content: "",
        studentNos: ""
    });

    async function okHandler() {
        if (!checkData()) return;

        setLoading(true);

        try {
            const students = makeTargetString(treeData, studentNos);
            await saveMessage({
                title,
                content,
                targetType: NoticeTargetType.Student,
                studentNos,
                students
            });
            message.success("发布成功!");
            onClose();
            handleClose();
            onSuccess();
        } catch (e) {
            message.error(errorMessage(e));
        }

        setLoading(false);
    }

    // 检查数据
    function checkData(): boolean {
        const err = { title: "", content: "", studentNos: "" };

        if (title.trim().length === 0) {
            err.title = "请填写标题";
        }

        if (studentNos.length === 0) {
            err.studentNos = "请选择通知范围";
        }

        setError(err);
        return _.every(Object.values(err), msg => msg.length === 0);
    }

    // 关闭时清空表单
    function handleClose() {
        onClose();
        setTitle("");
        setContent("");
        setStudentNos([]);
        setError({ title: "", content: "", studentNos: "" });
    }

    function onTitleChange(e: ChangeEvent<HTMLInputElement>) {
        setTitle(e.target.value);
        if (e.target.value.trim().length !== 0)
            setError({ ...error, title: "" });
    }

    function onStudentNosChange(studentNos: string[]) {
        setStudentNos(studentNos);
        if (studentNos.length !== 0) setError({ ...error, studentNos: "" });
    }

    return (
        <Modal
            className={style.root}
            visible={visible}
            title="新建通知"
            onOk={okHandler}
            width={750}
            style={{ top: 50 }}
            confirmLoading={loading}
            onCancel={handleClose}
            destroyOnClose
            maskClosable={false}>
            <div className={style.form}>
                <Row className={style.row}>
                    <Col span={6} className={style.label}>
                        <i>*</i> 标题:{" "}
                    </Col>
                    <Col span={18} className={style.inputWrapper}>
                        <Input
                            placeholder="请输入标题内容"
                            onChange={onTitleChange}
                            maxLength={120}
                        />
                        {error.title && (
                            <div className={style.error}>{error.title}</div>
                        )}
                    </Col>
                </Row>

                <Row className={style.row}>
                    <Col span={6} className={style.label}>
                        <i>*</i> 通知范围:{" "}
                    </Col>
                    <Col span={18} className={style.inputWrapper}>
                        <StudentPicker
                            onChange={onStudentNosChange}
                            treeData={treeData}
                        />
                        {error.studentNos && (
                            <div className={style.error}>
                                {error.studentNos}
                            </div>
                        )}
                    </Col>
                </Row>

                <Row className={style.row}>
                    <Col span={6} className={style.label}>
                        <i>*</i> 通知正文:{" "}
                    </Col>
                    <Col span={18} className={style.inputWrapper}>
                        <Editor data={content} onChange={setContent} />
                        {error.content && (
                            <div className={style.error}>{error.content}</div>
                        )}
                    </Col>
                </Row>

                {/*通知渠道暂时不做*/}
                {/*<Row className={style.row}>*/}
                {/*    <Col span={6} className={style.label}> 通知渠道: </Col>*/}
                {/*    <Col span={18} className={style.inputWrapper}>*/}
                {/*        <MsgChannel/>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
            </div>
        </Modal>
    );
}
